import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomLabel from "../common/customLabel";
import CustomInput from "../common/customInput";
import colors from "../../../config/colors";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  inputRegistro,
  customInputLabelProfile,
  btnConsumoDatoAfiliacion,
  btnTipoPlanDatoAfiliacion,
  labelInfoGeneralDatoAfiliacion,
  cerrarModalRegistro,
  gridNucleoContainerProfile,
  labelNucleoFamiliarProfile,
  botonBuscarSolicitudes,
} from "../../global/styles";
import CardMontoDisponible from "./cardMontoDisponible";
import BalanceSection from "./BalanceSection";
import UseIconHooks from "../../hooks/useIconHooks";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { createIdTag } from "../../utils/helpers";
import DialogNucleoFamiliar from "./dialogNucleoFamiliar";
import { ConfigurationContext } from "../../context/configurationContext";

const TabDatoAfiliacion = ({
  onNucleoFamiliarClick,
  nucleoFamiliar,
  nucleoFamiliarComplementario,
  onSelectNucleoMember,
}) => {
  const navigate = useNavigate();

  const {
    esDispositivoActualSeguro,
    idDispositivo,
    correoTitular,
    contratoTitular,
  } = useContext(ConfigurationContext);
  const [esDispositivoSeguro, setEsDispositivoSeguro] = useState(
    esDispositivoActualSeguro()
  );

  // Estados para manejo del núcleo familiar
  const [openNucleo, setOpenNucleo] = useState(false);
  const [nucleoActual, setNucleoActual] = useState([]);

  const perfilUsuario = useSelector(
    (state) => state.afiliado.infoPerfilUsuario
  );
  const featureFlags = useSelector((state) => state.configuration.feauteFlags);
  const [datos, setDatos] = useState(perfilUsuario);

  // Handlers para núcleo familiar
  const handlerCloseNucleo = () => setOpenNucleo(false);

  const handlerNucleoFamiliarPorTab = (idTipoPlan) => {
    if (idTipoPlan === 1) {
      // Plan CONTRIBUTIVO usa nucleoFamiliar
      const participantes = nucleoFamiliar ? nucleoFamiliar.participantes : [];
      setNucleoActual(participantes);
    } else if (idTipoPlan === 2) {
      // Plan PREMIUM usa nucleoFamiliarComplementario
      const participantes = nucleoFamiliarComplementario
        ? nucleoFamiliarComplementario.participantes
        : [];
      setNucleoActual(participantes);
    }
    setOpenNucleo(true);
  };

  const handlerSelectNucleoMember = (member) => {
    if (onSelectNucleoMember) {
      onSelectNucleoMember(member);
    }
    setOpenNucleo(false);
  };

  // Handler para cuando cambia el estado de dispositivo seguro
  const handleDispositivoSeguroChange = (isSeguro) => {
    setEsDispositivoSeguro(isSeguro);
  };

  useEffect(() => {
    setDatos(perfilUsuario);
  }, [perfilUsuario]);
  const tabInicial = datos.datosAfiliacion
    ? datos.datosAfiliacion.filter((a) => a.idTipoPlan !== 3)[0].idTipoPlan
    : null;
  const infoGeneralInicial = datos.datosAfiliacion
    ? datos.datosAfiliacion[0]
    : null;
  const [tab, setTab] = useState(tabInicial);
  const [infoGeneralActual, setInfoGeneralActual] = useState(
    datos.datosAfiliacion ? datos.datosAfiliacion[0] : null
  );

  const handlerTab = (item) => {
    setInfoGeneralActual(item);
    setTab(item.idTipoPlan);
  };

  const handlerButtonComponent = (item) => {
    // Navegar a la página de medicamentos
    navigate('/consulta/medicamentos');
  };

  const ButtonComponent = (item) => (
    <Button
      id="btn-ver-consumos"
      variant="contained"
      startIcon={UseIconHooks("visibility", { fontSize: "small" })}
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "8px",
        color: "white",
        fontSize: "12px",
        fontWeight: "600",
        padding: "8px 16px",
        textTransform: "none",
        boxShadow: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.25)",
          transform: "translateY(-1px)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        },
      }}
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "8px",
        color: "white",
        fontSize: "12px",
        fontWeight: "600",
        padding: "8px 16px",
        textTransform: "none",
        boxShadow: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.25)",
          transform: "translateY(-1px)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        },
      }}
      onClick={(event) => {
        handlerButtonComponent(item);
      }}
    >
      Ver consumos
    </Button>
  );

  return (
    <>
      {datos.datosAfiliacion ? (
        <>
          <div style={{ padding: 5, width: "100%" }}>
            <ButtonGroup
              fullWidth
              variant="text"
              aria-label="outlined primary button group"
              style={{
                backgroundColor: colors.grayLight,
              }}
            >
              {datos.datosAfiliacion
                .filter((a) => a.idTipoPlan !== 3 && a.tipoPlan !== null)
                .map((item) => (
                  <Button
                    id={createIdTag("btn", item.tipoPlan)}
                    key={item.idTipoPlan}
                    style={{
                      ...btnTipoPlanDatoAfiliacion,
                      backgroundColor:
                        tab === item.idTipoPlan
                          ? colors.primary
                          : colors.grayLight,
                      color: tab === item.idTipoPlan ? "white" : colors.gray,
                    }}
                    onClick={() => handlerTab(item)}
                  >
                    {item.tipoPlan}
                  </Button>
                ))}
            </ButtonGroup>
          </div>
        </>
      ) : null}

      {infoGeneralInicial ? (
        <Grid container paddingX={5} paddingTop={2} spacing={2}>
          <Grid item xs={12}>
            <CustomLabel
              style={{
                ...labelInfoGeneralDatoAfiliacion,
              }}
            >
              Información general
            </CustomLabel>
          </Grid>
          <Grid item md={4} xs={12}>
            <CustomInput
              id="input-tipo-afiliacion"
              label="Tipo de afiliación"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={datos.datosPersonales.tipoAfiliacion}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <CustomInput
              id="input-estado-afiliacion"
              label="Estado de servicio"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={infoGeneralActual.estado}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <CustomInput
              id="input-fecha-afiliacion"
              label="Fecha de afiliación"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={
                infoGeneralActual.fechaAfiliacion !== null
                  ? format(
                      new Date(infoGeneralActual.fechaAfiliacion),
                      "dd-MM-yyyy"
                    )
                  : ""
              }
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              id="input-fecha-1era-cotizacion"
              label="Fecha de 1era cotización"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={
                infoGeneralActual.primeraDispersion !== null
                  ? format(
                      new Date(infoGeneralActual.primeraDispersion),
                      "dd-MM-yyyy"
                    )
                  : ""
              }
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              input="input-fecha-ultima-cotizacion"
              label="Fecha de última cotización"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={
                infoGeneralActual.ultimaDispersion !== null
                  ? format(
                      new Date(infoGeneralActual.ultimaDispersion),
                      "dd-MM-yyyy"
                    )
                  : ""
              }
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              id="input-fecha-inicio-vigencia"
              label="Fecha de inicio de vigencia"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={
                infoGeneralActual.inicioVigencia !== null
                  ? format(
                      new Date(infoGeneralActual.inicioVigencia),
                      "dd-MM-yyyy"
                    )
                  : ""
              }
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              id="input-fecha-fin-vigencia"
              label="Fecha de fin de vigencia"
              style={{ ...inputRegistro }}
              labelStyle={{ ...customInputLabelProfile }}
              value={
                infoGeneralActual.finVigencia !== null
                  ? format(
                      new Date(infoGeneralActual.finVigencia),
                      "dd-MM-yyyy"
                    )
                  : ""
              }
            />
          </Grid>

          {/* Sección del Núcleo Familiar */}
          {datos.datosPersonales &&
          datos.datosPersonales.tipoAfiliacion === "Titular" &&
          featureFlags.verNucleoFamiliar ? (
            <Grid item xs={12} marginTop={2}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={UseIconHooks("group", {
                  fontSize: "medium",
                })}
                onClick={() =>
                  handlerNucleoFamiliarPorTab(infoGeneralActual.idTipoPlan)
                }
                style={{
                  padding: "12px 16px",
                  border: `2px solid ${colors.primary}`,
                  borderRadius: "8px",
                  color: colors.primary,
                  backgroundColor: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: colors.primary,
                    color: "white",
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                  },
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: colors.primary,
                    color: "white",
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                  },
                }}
              >
                Ver Núcleo Familiar
              </Button>
            </Grid>
          ) : null}

          {infoGeneralActual.balances &&
          featureFlags.disponibleMedicamentos &&
          infoGeneralActual.balances.length > 0 ? (
            <BalanceSection
              infoGeneralActual={infoGeneralActual}
              datos={datos}
              esDispositivoSeguro={esDispositivoSeguro}
              ButtonComponent={ButtonComponent}
              onDispositivoSeguroChange={handleDispositivoSeguroChange}
            />
          ) : null}
        </Grid>
      ) : null}

      {/* Dialog del Núcleo Familiar */}
      <DialogNucleoFamiliar
        open={openNucleo}
        handlerClose={handlerCloseNucleo}
        nucleo={nucleoActual}
        onPress={handlerSelectNucleoMember}
      />
    </>
  );
};

export default TabDatoAfiliacion;